<template>
  <div class="merge">
    <el-dialog
      title="合并"
      :visible.sync="dialogVisible"
      width="50%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="container">
        <el-form
          inline
          :model="mergeData"
          :rules="mergeDataRules"
          ref="mergeData"
          label-width="60px"
        >
          <el-form-item label="原编码" prop="partnerCodeOld">
            <el-input v-model="mergeData.partnerCodeOld"></el-input>
          </el-form-item>
          <el-form-item label="改为" prop="partnerCodeNew">
            <el-input v-model="mergeData.partnerCodeNew"></el-input>
          </el-form-item>
        </el-form>
        <el-progress :percentage="progress" :status="status"></el-progress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/cooperation';
  export default {
    name: 'merge',
    data() {
      return {
        dialogVisible: false,
        progress: 0,
        status: null,
        propsData: null, // 父组件传递过来的数据
        mergeData: {
          partnerCodeOld: '', // 原编码
          partnerCodeNew: '', // 新编码
        },
        mergeDataRules: {
          // 校验规则
          partnerCodeOld: [{ required: true, message: '请输入原编码', trigger: 'blur' }],
          partnerCodeNew: [{ required: true, message: '请输入新编码', trigger: 'blur' }],
        },
      };
    },
    methods: {
      openDialog(data) {
        this.progress = 0;
        this.status = null;
        this.dialogVisible = true;
        this.propsData = data;
        this.mergeData.partnerCodeOld = this.propsData.partnerCode;
      },
      // 确定
      handleSure() {
        this.progress = 20;
        this.$refs.mergeData.validate((valid) => {
          if (valid) {
            if (this.mergeData.partnerCodeOld === this.mergeData.partnerCodeNew) {
              this.progress = 100;
              this.$message({
                showClose: true,
                message: this.$t('cooperation.message.checkrest'),
                type: 'error',
              });
            } else {
              this.$axios.post(API.UPDATE_MERGE, this.mergeData).then((res) => {
                if (res.data.code === 0) {
                  this.progress = 100;
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  this.handleClose();
                  this.$emit('refreshData');
                } else {
                  this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                  this.status = 'exception';
                }
              });
            }
          }
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$refs.mergeData.resetFields();
      },
    },
  };
</script>

<style scoped>
  .merge .container {
    text-align: center;
  }
</style>
